<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Add New Sub-Category</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <form
        [formGroup]="addSubCategoryForm"
        (ngSubmit)="addSubCategoryForm.valid && saveSubCategory()"
        novalidate
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <mat-form-field
              appearance="fill"
              *ngIf="productOptions.length > 0"
              color="accent"
            >
              <mat-label>Product</mat-label>
              <mat-select
                (selectionChange)="onSelectionchange($event)"
                formControlName="productId"
              >
                <mat-option [value]="null">Select an option</mat-option>
                <mat-option
                  *ngFor="let product of productOptions"
                  [value]="product.productId"
                >
                  {{ product.productName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  addSubCategoryForm.get('productId')?.hasError('required') &&
                  addSubCategoryForm.get('productId')?.touched
                "
              >
                Product is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div
            class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
            *ngIf="categoryOptions.length > 0"
          >
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Category</mat-label>
              <mat-select formControlName="categoryId" color="accent">
                <mat-option [value]="null">Select an option</mat-option>
                <mat-option
                  *ngFor="let cat of categoryOptions; let i = index"
                  [value]="cat.categoryId"
                >
                  {{ cat.productCategoryName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  addSubCategoryForm.get('categoryId').hasError('required')
                "
              >
                Category is required.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <mat-form-field color="accent" appearance="fill" color="accent">
              <mat-label>Sub-Category Name</mat-label>
              <input
                matInput
                type="text"
                placeholder="subCategoryName"
                name="subCategoryName"
                id="subCategoryName"
                formControlName="subCategoryName"
                autocomplete="off"
                appInputValidator
              [sanitizeScriptTags]="true"
              [hasAtLeastOneAlphabet]="true"
              />
              <mat-error
                *ngIf="
                  addSubCategoryForm.get('subCategoryName').hasError('required')
                "
              >
                Subcategory Name is required.
              </mat-error>
              <mat-error *ngIf="addSubCategoryForm.get('subCategoryName').hasError('maxlength')">
                SubCategory Name cannot be more than 50 characters.
              </mat-error>
               <mat-error *ngIf="addSubCategoryForm.get('subCategoryName').hasError('noAlphabet')">
              Must contain at least one alphabet.
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <mat-form-field color="accent" appearance="fill" color="accent">
              <mat-label>Description</mat-label>
              <input
                matInput
                type="text"
                placeholder="description"
                name="description"
                id="description"
                formControlName="description"
                autocomplete="off"
                appInputValidator
              [sanitizeScriptTags]="true"
              [hasAtLeastOneAlphabet]="true"
              />
              <mat-error
              *ngIf="
                addSubCategoryForm.get('description')?.hasError('required') &&
                addSubCategoryForm.get('description')?.touched
              "
            >
              Description is required.
            </mat-error>
            <mat-error *ngIf="addSubCategoryForm.get('description').hasError('maxlength')">
              Description cannot be more than 100 characters.
            </mat-error>
             <mat-error *ngIf="addSubCategoryForm.get('description').hasError('noAlphabet')">
              Must contain at least one alphabet.
            </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <button
            md-raised-button
            type="button"
            class="btn btn-round btn-block btn-rose"
            (click)="close()"
          >
            Close
          </button>
        </div>
        <div class="col-md-3">
          <button
            md-raised-button
            type="button"
            class="btn btn-round btn-block btn-rose"
            (click)="saveSubCategory()"
            [disabled]="!addSubCategoryForm.valid"
          >
            Save
          </button>
        </div>
        <div class="col-md-3"></div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
